// extracted by mini-css-extract-plugin
export default {"row":"SearchResultPage_row__3vHNC"};